import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import { ModelFilterSchema } from '../model-filter-schema.ts'
import { NonEmptyStringSchema } from './property.models.ts'
import { LocationIdSchema, PlaceIdSchema } from './unique-id.models.ts'

/**
 * LocationDomainSelectModel
 */
export const LocationDomainSelectModelSchema = z.object({
  locationId: LocationIdSchema,
  placeId: PlaceIdSchema,
  name: NonEmptyStringSchema(),
  address: NonEmptyStringSchema().optional(),
})

export type LocationDomainSelectModel = ZodInfer<
  typeof LocationDomainSelectModelSchema
>

/**
 * LocationDomainInsertModel
 */
export const LocationDomainInsertModelSchema =
  LocationDomainSelectModelSchema.partial({ locationId: true })

export type LocationDomainInsertModel = ZodInfer<
  typeof LocationDomainInsertModelSchema
>

/**
 * LocationDomainUpdateModel
 */
export const LocationDomainUpdateModelSchema =
  LocationDomainSelectModelSchema.pick({
    name: true,
  })
    .extend({
      address: LocationDomainSelectModelSchema.shape.address
        .unwrap()
        .nullable(),
    })
    .partial()

export type LocationDomainUpdateModel = ZodInfer<
  typeof LocationDomainUpdateModelSchema
>

/**
 * LocationDomainSelectModelFilter
 */
export const LocationDomainSelectModelFiltersSchema = z
  .object({
    locationId: ModelFilterSchema(LocationIdSchema),
    placeId: ModelFilterSchema(PlaceIdSchema),
    search: NonEmptyStringSchema(),
  })
  .partial()

export type LocationDomainSelectModelFilters = ZodInfer<
  typeof LocationDomainSelectModelFiltersSchema
>
